/// <amd-module name="Artifacts/Package/components/SearchUpstreamsIngestionPanel" />
import * as PackageRes from "Artifacts/Package/Resources";
import { IPackageDetailsModuleState, PackageActions } from "Artifacts/Package/redux";
import { ComponentState } from "Artifacts/Root/Constants";
import * as Res from "Artifacts/Root/Resources";
import { ErrorBannerLoader } from "Artifacts/Root/components/ErrorBannerLoader";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { isLoading } from "Artifacts/Root/helpers/ComponentStateHelpers";
import { encodeNameOrVersionForPackagingUriPath } from "Artifacts/Root/helpers/PackageDecoderHelper";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import * as Utils_String from "VSS/Core/Util/String";
import { Dialog } from "VSSUI/Dialog";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import * as React from "react";
import { connect } from "react-redux";

export const SearchUpstreamsIngestionPanelId = "SearchUpstreamsIngestionPanel";

export interface ISearchUpstreamsIngestionPanelProps {
  onDismiss: () => void;
  protocolName: string;
  packageNormalizedName: string;
  packageDisplayName: string;
  packageVersion: string;
  upstreamIngestionComponentState: ComponentState;
}

interface IMapStateToProps {
  upstreamIngestionComponentState: ComponentState;
}

const Actions = {
  ingestFromUpstream: PackageActions.ingestFromUpstream,
};

const mapStateToProps = (state: IPackageDetailsModuleState): IMapStateToProps => {
  return {
    upstreamIngestionComponentState: state.packageState.ui.upstreamIngestionComponentState,
  };
};

// We may need to use a panel for multi-file protocol
const SearchUpstreamsIngestionPanel: React.FC<ISearchUpstreamsIngestionPanelProps &
  typeof Actions> = ({
  onDismiss,
  protocolName,
  packageNormalizedName,
  packageDisplayName,
  packageVersion,
  upstreamIngestionComponentState,
  ingestFromUpstream,
}) => {
  const feed = useFeed().feed;

  return (
    <Dialog
      className="search-upstreams-ingestion-panel"
      titleProps={{ text: PackageRes.PackageIngestion_ModalTitle }}
      lightDismiss={false}
      onDismiss={onDismiss}
      footerButtonProps={[
        {
          onClick: onDismiss,
          text: Res.Modal_Cancel,
        },
        {
          primary: true,
          onClick: () => {
            feed &&
              ingestFromUpstream(
                onDismiss,
                feed.id,
                protocolName,
                encodeNameOrVersionForPackagingUriPath(packageDisplayName),
                encodeNameOrVersionForPackagingUriPath(packageVersion),
                feed.project?.name,
              );
          },
          text: PackageRes.SaveButtonPackageFromUpstream,
          iconProps: isLoading(upstreamIngestionComponentState)
            ? {
                render: (className) => <Spinner className={className} size={SpinnerSize.small} />,
              }
            : undefined,
        },
      ]}
    >
      <ErrorBannerLoader
        state={upstreamIngestionComponentState}
        noLoadingSpinner
        errorClassName="margin-bottom-8"
      >
        {Utils_String.format(PackageRes.UpstreamSaveToFeed, packageDisplayName, packageVersion)}
      </ErrorBannerLoader>
    </Dialog>
  );
};

const SearchUpstreamsIngestionModals = connect<
  IMapStateToProps,
  typeof Actions,
  ISearchUpstreamsIngestionPanelProps
>(
  mapStateToProps,
  Actions,
)(SearchUpstreamsIngestionPanel);

registerModal(SearchUpstreamsIngestionPanelId, SearchUpstreamsIngestionModals);
